"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLayout = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const helpers_1 = require("./helpers");
require("./types");
require("./helpers/constants");
const ColoredView = styled_components_1.default(components_1.View) `
  background-color: ${(props) => helpers_1.getBackgroundColor(props.backgroundColorView)};
`;
const ColoredBodyLayout = styled_components_1.default(components_1.BodyLayout) `
  background-color: ${(props) => helpers_1.getBackgroundColor(props.backgroundColorView)};
`;
const PageLayout = ({ id, tabBarItems, isLoading, size, backgroundView, children, }) => {
    const loadingContent = (react_1.default.createElement(components_1.BodyLayout, { "data-selector-id": id, initialize: true, content: null, style: helpers_1.getFullSizeStyle() }));
    if (tabBarItems === null || tabBarItems === void 0 ? void 0 : tabBarItems.length) {
        return (react_1.default.createElement(ColoredView, { style: helpers_1.getFullSizeStyle() },
            react_1.default.createElement(components_1.TabsLayout, { "data-selector-id": id, tabs: react_1.default.createElement(components_1.TabBar, { items: tabBarItems }), body: isLoading ? react_1.default.createElement(react_1.default.Fragment, null, loadingContent) : react_1.default.createElement(react_1.default.Fragment, null, children) })));
    }
    return (react_1.default.createElement(ColoredBodyLayout, { backgroundColorView: backgroundView, "data-selector-id": id, initialize: isLoading, content: children, style: helpers_1.getSizeStyle(size) }));
};
exports.PageLayout = PageLayout;
exports.PageLayout.displayName = 'PageLayout';
//# sourceMappingURL=PageLayout.js.map